import styled from 'styled-components';

export default styled.div`
    position: relative;
    height: 100%;

    .react-resizable-handle {
        background-size: cover;
        width: 10px;
        height: 10px;
    }
`;
